import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Container } from '@material-ui/core';
import { TabsShowRequest } from 'components/Tables/InviteTable';
import { useStyles } from './styles';

const EmailInvite: FC = observer(() => {
  const classes = useStyles();
  return (
    <Container maxWidth='xl' className={classes.container}>
      <TabsShowRequest />
    </Container>
  );
});

export default EmailInvite;
